import type { GallerySM } from '@/components/ProductCard/types'
import { useTranslation } from 'react-i18next'
import { DataFallback } from './DataFallback'
// import { ColorsVariations } from './ColorsVariations'
import { ProductBrand } from './ProductBrand'
import { ProductComposition } from './ProductComposition'
import { ProductNature } from './ProductNature'
import { displayGenders } from './utils'
import './product-compo-variations.scss'

export function ProductCompoVariations({
  productSM,
  showBrand = true,
  // showColors = true,
  showGender = true,
  showProductNature = true,
  showComposition = true,
}: Readonly<{
  productSM: GallerySM
  showBrand?: boolean
  // showColors?: boolean
  showSizes?: boolean
  showGender?: boolean
  showProductNature?: boolean
  showComposition?: boolean
}>) {
  const { t } = useTranslation()

  return (
    <section
      className="product-card-compo-variations"
      data-testid="product-card_compo-variations"
    >
      {/* {showColors && <ColorsVariations colors={productSM.colors} />} */}
      {showBrand && (
        <ProductBrand id={productSM.brand?.id.toString()} />
      )}
      {showGender && (
        <div className="product-gender" data-testid="product_gender">
          <span className="sr-only">
            {t('products-page.filters.groups.genders')}
            :
            {' '}
          </span>
          <DataFallback
            value={productSM.genders}
            fallbackKey="products-page.product-card.no-gender"
            isEmpty={items => items.length === 0}
          >
            {genders => displayGenders(genders, t)}
          </DataFallback>
        </div>
      )}
      {showProductNature && (
        <ProductNature id={productSM.product_nature?.id} />
      )}
      {showComposition && (
        <ProductComposition composition={productSM.composition} />
      )}
    </section>
  )
}
